import { motion } from "framer-motion";
import { Maximize2, Clock } from "lucide-react";
import { useLang, ASSETS } from "../i18n";

export const Panoramic = () => {
  const { t } = useLang();
  return (
    <section className="relative py-28 md:py-36 bg-[var(--c-bg)]">
      <div className="max-w-7xl mx-auto px-6 md:px-10">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.7 }}
          className="relative rounded-3xl overflow-hidden border border-dashed border-[var(--c-gold)]/30 bg-[var(--c-bg-3)]"
          data-testid="panoramic-placeholder"
        >
          <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_center,rgba(212,175,55,0.08),transparent_70%)]" />
          <img
            src={ASSETS.mercedes}
            alt=""
            className="pointer-events-none absolute right-0 bottom-0 w-1/3 opacity-10 hidden md:block"
          />
          <div className="relative px-8 md:px-16 py-20 md:py-28 flex flex-col items-center text-center">
            <div className="flex items-center gap-2 mb-6 text-[var(--c-gold)]">
              <Clock size={15} />
              <span className="overline">{t.pano.tag}</span>
            </div>
            <h2 className="font-display text-4xl sm:text-5xl md:text-6xl font-semibold text-white max-w-3xl">
              {t.pano.title}
            </h2>
            <p className="mt-6 text-neutral-400 max-w-xl">{t.pano.sub}</p>
            <div className="mt-10 inline-flex items-center gap-3 px-6 py-4 rounded-full gold-border bg-black/30">
              <Maximize2 size={18} className="text-[var(--c-gold)]" />
              <span className="font-mono text-xs uppercase tracking-[0.25em] text-neutral-300">{t.pano.soon}</span>
            </div>
          </div>
        </motion.div>
      </div>
    </section>
  );
};
